import { render, staticRenderFns } from "./PlaybookGroup.vue?vue&type=template&id=65785f6a&scoped=true"
import script from "./PlaybookGroup.vue?vue&type=script&lang=js"
export * from "./PlaybookGroup.vue?vue&type=script&lang=js"
import style0 from "./PlaybookGroup.vue?vue&type=style&index=0&id=65785f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65785f6a",
  null
  
)

export default component.exports